// Reducer

import {
  GET_PRODUCT_LIST,
  GET_PRODUCT_LIST_SUCCESS,
  GET_PRODUCT_LIST_ERROR,
  GET_PRODUCT_UNIT_TYPE_LIST,
  GET_PRODUCT_UNIT_TYPE_LIST_SUCCESS,
  GET_PRODUCT_UNIT_TYPE_LIST_ERROR,
  ADD_PRODUCT_UNIT_TYPE,
  ADD_PRODUCT_UNIT_TYPE_SUCCESS,
  ADD_PRODUCT_UNIT_TYPE_ERROR,
  UPDATE_PRODUCT_UNIT_TYPE,
  UPDATE_PRODUCT_UNIT_TYPE_SUCCESS,
  UPDATE_PRODUCT_UNIT_TYPE_ERROR,
  DELETE_PRODUCT_UNIT_TYPE,
  DELETE_PRODUCT_UNIT_TYPE_SUCCESS,
  DELETE_PRODUCT_UNIT_TYPE_ERROR,
  GET_PRODUCT_STOCK_STORAGE_LOCATION_LIST,
  GET_PRODUCT_STOCK_STORAGE_LOCATION_LIST_SUCCESS,
  GET_PRODUCT_STOCK_STORAGE_LOCATION_LIST_ERROR,
  GET_PRODUCT_STOCK_STORAGE_LOCATION_DATA,
  GET_PRODUCT_STOCK_STORAGE_LOCATION_DATA_SUCCESS,
  GET_PRODUCT_STOCK_STORAGE_LOCATION_DATA_ERROR,
  CREATE_PRODUCT_STOCK_STORAGE_LOCATION,
  CREATE_PRODUCT_STOCK_STORAGE_LOCATION_SUCCESS,
  CREATE_PRODUCT_STOCK_STORAGE_LOCATION_ERROR,
  UPDATE_PRODUCT_STOCK_STORAGE_LOCATION,
  UPDATE_PRODUCT_STOCK_STORAGE_LOCATION_SUCCESS,
  UPDATE_PRODUCT_STOCK_STORAGE_LOCATION_ERROR,
  DELETE_PRODUCT_STOCK_STORAGE_LOCATION,
  DELETE_PRODUCT_STOCK_STORAGE_LOCATION_SUCCESS,
  DELETE_PRODUCT_STOCK_STORAGE_LOCATION_ERROR,
  GET_PRODUCT_STOCK_LIST,
  GET_PRODUCT_STOCK_LIST_SUCCESS,
  GET_PRODUCT_STOCK_LIST_ERROR,
  SEARCH_PRODUCT_STOCK,
  SEARCH_PRODUCT_STOCK_SUCCESS,
  SEARCH_PRODUCT_STOCK_ERROR,
  SEARCH_PRODUCT_STOCK_TRANSACTION,
  SEARCH_PRODUCT_STOCK_TRANSACTION_SUCCESS,
  SEARCH_PRODUCT_STOCK_TRANSACTION_ERROR,
  GET_PRODUCT_STOCK_TRANSACTION_LIST,
  GET_PRODUCT_STOCK_TRANSACTION_LIST_SUCCESS,
  GET_PRODUCT_STOCK_TRANSACTION_LIST_ERROR,
  ADD_PRODUCT_STOCK_TRANSACTION,
  ADD_PRODUCT_STOCK_TRANSACTION_SUCCESS,
  ADD_PRODUCT_STOCK_TRANSACTION_ERROR,
  MOVE_PRODUCT_STOCK_TRANSACTION,
  MOVE_PRODUCT_STOCK_TRANSACTION_SUCCESS,
  MOVE_PRODUCT_STOCK_TRANSACTION_ERROR,
  REDUCE_PRODUCT_STOCK_TRANSACTION,
  REDUCE_PRODUCT_STOCK_TRANSACTION_SUCCESS,
  REDUCE_PRODUCT_STOCK_TRANSACTION_ERROR,
  GET_PRODUCT_STOCK_TRANSACTION_REASON_LIST,
  GET_PRODUCT_STOCK_TRANSACTION_REASON_LIST_SUCCESS,
  GET_PRODUCT_STOCK_TRANSACTION_REASON_LIST_ERROR,
  CREATE_PRODUCT_STOCK_TRANSACTION_REASON,
  CREATE_PRODUCT_STOCK_TRANSACTION_REASON_SUCCESS,
  CREATE_PRODUCT_STOCK_TRANSACTION_REASON_ERROR,
  UPDATE_PRODUCT_STOCK_TRANSACTION_REASON,
  UPDATE_PRODUCT_STOCK_TRANSACTION_REASON_SUCCESS,
  UPDATE_PRODUCT_STOCK_TRANSACTION_REASON_ERROR,
  DELETE_PRODUCT_STOCK_TRANSACTION_REASON,
  DELETE_PRODUCT_STOCK_TRANSACTION_REASON_SUCCESS,
  DELETE_PRODUCT_STOCK_TRANSACTION_REASON_ERROR,
  GET_UNIT_MEASUREMENT_LIST,
  GET_UNIT_MEASUREMENT_LIST_SUCCESS,
  GET_UNIT_MEASUREMENT_LIST_ERROR,
} from "./actionType";

const INIT_STATE = {
  productList: [],
  productUnitTypeList: [],
  addProductUnitTypeSuccess: [],
  addProductUnitTypeError: [],
  updateProductUnitTypeSuccess: [],
  updateProductUnitTypeError: [],
  deleteProductUnitTypeSuccess: [],
  deleteProductUnitTypeError: [],
  //stock storage location
  productStockStorageLocationListSuccess: [],
  productStockStorageLocationListError: [],
  productStockStorageLocationListLoading: false,

  productStockStorageLocationDataSuccess: [],
  productStockStorageLocationDataError: [],
  productStockStorageLocationDataLoading: false,

  createProductStockStorageLocationSuccess: [],
  createProductStockStorageLocationError: [],
  createProductStockStorageLocationLoading: false,

  updateProductStockStorageLocationSuccess: [],
  updateProductStockStorageLocationError: [],
  updateProductStockStorageLocationLoading: false,

  deleteProductStockStorageLocationSuccess: [],
  deleteProductStockStorageLocationError: [],
  deleteProductStockStorageLocationLoading: false,

  //stock location
  productStockList: [],
  productStockListSuccess: [],
  productStockListError: [],
  productStockListLoading: false,
  searchProductStockSuccess: [],
  searchProductStockError: [],
  searchProductStockLoading: false,

  //stock transaction
  searchProductStockTransactionSuccess: [],
  searchProductStockTransactionError: [],
  searchProductStockTransactionLoading: false,
  productStockTransactionListSuccess: [],
  productStockTransactionListError: [],
  productStockTransactionListLoading: false,

  addProductStockTransactionSuccess: [],
  addProductStockTransactionError: [],
  addProductStockTransactionLoading: false,

  moveProductStockTransactionSuccess: [],
  moveProductStockTransactionError: [],
  moveProductStockTransactionLoading: false,

  reduceProductStockTransactionSuccess: [],
  reduceProductStockTransactionError: [],
  reduceProductStockTransactionLoading: false,

  //stock transaction reduction reason picklist
  productStockTransactionReasonListSuccess: [],
  productStockTransactionReasonListError: [],
  productStockTransactionReasonListLoading: false,

  createProductStockTransactionReasonSuccess: [],
  createProductStockTransactionReasonError: [],
  createProductStockTransactionReasonLoading: false,

  updateProductStockTransactionReasonSuccess: [],
  updateProductStockTransactionReasonError: [],
  updateProductStockTransactionReasonLoading: false,

  deleteProductStockTransactionReasonSuccess: [],
  deleteProductStockTransactionReasonError: [],
  deleteProductStockTransactionReasonLoading: false,

  //GET_UNIT_MEASUREMENT_LIST
  unitMeasurementList: [],
  unitMeasurementListSuccess: [],
  unitMeasurementListError: [],
  unitMeasurementListLoading: false,
};

const ProductCrmIT = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PRODUCT_LIST:
      return { ...state, productList: [] };
    case GET_PRODUCT_LIST_SUCCESS:
      return { ...state, productList: action.payload };
    case GET_PRODUCT_LIST_ERROR:
      return { ...state, productList: [] };
    case GET_PRODUCT_UNIT_TYPE_LIST:
      return { ...state, productUnitTypeList: [] };
    case GET_PRODUCT_UNIT_TYPE_LIST_SUCCESS:
      return { ...state, productUnitTypeList: action.payload };
    case GET_PRODUCT_UNIT_TYPE_LIST_ERROR:
      return { ...state, productUnitTypeList: [] };
    case ADD_PRODUCT_UNIT_TYPE:
      return { ...state };
    case ADD_PRODUCT_UNIT_TYPE_SUCCESS:
      return { ...state, addProductUnitTypeSuccess: action.payload };
    case ADD_PRODUCT_UNIT_TYPE_ERROR:
      return { ...state, addProductUnitTypeError: action.payload };
    case UPDATE_PRODUCT_UNIT_TYPE:
      return { ...state };
    case UPDATE_PRODUCT_UNIT_TYPE_SUCCESS:
      return { ...state, updateProductUnitTypeSuccess: action.payload };
    case UPDATE_PRODUCT_UNIT_TYPE_ERROR:
      return { ...state, updateProductUnitTypeError: action.payload };
    case DELETE_PRODUCT_UNIT_TYPE:
      return { ...state };
    case DELETE_PRODUCT_UNIT_TYPE_SUCCESS:
      return { ...state, deleteProductUnitTypeSuccess: action.payload };
    case DELETE_PRODUCT_UNIT_TYPE_ERROR:
      return { ...state, deleteProductUnitTypeError: action.payload };
    case GET_PRODUCT_STOCK_STORAGE_LOCATION_LIST:
      return {
        ...state,
        productStockStorageLocationListSuccess: [],
        productStockStorageLocationListError: [],
        productStockStorageLocationListLoading: true,
      };
    case GET_PRODUCT_STOCK_STORAGE_LOCATION_LIST_SUCCESS:
      return {
        ...state,
        productStockStorageLocationListSuccess: action.payload,
        productStockStorageLocationListError: [],
        productStockStorageLocationListLoading: false,
      };
    case GET_PRODUCT_STOCK_STORAGE_LOCATION_LIST_ERROR:
      return {
        ...state,
        productStockStorageLocationListSuccess: [],
        productStockStorageLocationListError: action.payload,
        productStockStorageLocationListLoading: false,
      };
    case GET_PRODUCT_STOCK_STORAGE_LOCATION_DATA:
      return {
        ...state,
        productStockStorageLocationDataSuccess: [],
        productStockStorageLocationDataError: [],
        productStockStorageLocationDataLoading: true,
      };
    case GET_PRODUCT_STOCK_STORAGE_LOCATION_DATA_SUCCESS:
      return {
        ...state,
        productStockStorageLocationDataSuccess: action.payload,
        productStockStorageLocationDataError: [],
        productStockStorageLocationDataLoading: false,
      };
    case GET_PRODUCT_STOCK_STORAGE_LOCATION_DATA_ERROR:
      return {
        ...state,
        productStockStorageLocationDataSuccess: [],
        productStockStorageLocationDataError: action.payload,
        productStockStorageLocationDataLoading: false,
      };
    case CREATE_PRODUCT_STOCK_STORAGE_LOCATION:
      return {
        ...state,
        createProductStockStorageLocationSuccess: [],
        createProductStockStorageLocationError: [],
        createProductStockStorageLocationLoading: true,
      };
    case CREATE_PRODUCT_STOCK_STORAGE_LOCATION_SUCCESS:
      return {
        ...state,
        createProductStockStorageLocationSuccess: action.payload,
        createProductStockStorageLocationError: [],
        createProductStockStorageLocationLoading: false,
      };
    case CREATE_PRODUCT_STOCK_STORAGE_LOCATION_ERROR:
      return {
        ...state,
        createProductStockStorageLocationSuccess: [],
        createProductStockStorageLocationError: action.payload,
        createProductStockStorageLocationLoading: false,
      };
    case UPDATE_PRODUCT_STOCK_STORAGE_LOCATION:
      return {
        ...state,
        updateProductStockStorageLocationSuccess: [],
        updateProductStockStorageLocationError: [],
        updateProductStockStorageLocationLoading: true,
      };
    case UPDATE_PRODUCT_STOCK_STORAGE_LOCATION_SUCCESS:
      return {
        ...state,
        updateProductStockStorageLocationSuccess: action.payload,
        updateProductStockStorageLocationError: [],
        updateProductStockStorageLocationLoading: false,
      };
    case UPDATE_PRODUCT_STOCK_STORAGE_LOCATION_ERROR:
      return {
        ...state,
        updateProductStockStorageLocationSuccess: [],
        updateProductStockStorageLocationError: action.payload,
        updateProductStockStorageLocationLoading: false,
      };
    case DELETE_PRODUCT_STOCK_STORAGE_LOCATION:
      return {
        ...state,
        deleteProductStockStorageLocationSuccess: [],
        deleteProductStockStorageLocationError: [],
        deleteProductStockStorageLocationLoading: true,
      };
    case DELETE_PRODUCT_STOCK_STORAGE_LOCATION_SUCCESS:
      return {
        ...state,
        deleteProductStockStorageLocationSuccess: action.payload,
        deleteProductStockStorageLocationError: [],
        deleteProductStockStorageLocationLoading: false,
      };
    case DELETE_PRODUCT_STOCK_STORAGE_LOCATION_ERROR:
      return {
        ...state,
        deleteProductStockStorageLocationSuccess: [],
        deleteProductStockStorageLocationError: action.payload,
        deleteProductStockStorageLocationLoading: false,
      };
    case GET_PRODUCT_STOCK_LIST:
      return {
        ...state,
        productStockListSuccess: [],
        productStockListError: [],
        productStockListLoading: true,
      };
    case GET_PRODUCT_STOCK_LIST_SUCCESS:
      return {
        ...state,
        productStockListSuccess: action.payload,
        productStockListError: [],
        productStockListLoading: false,
      };
    case GET_PRODUCT_STOCK_LIST_ERROR:
      return {
        ...state,
        productStockListSuccess: [],
        productStockListError: action.payload,
        productStockListLoading: false,
      };
    case SEARCH_PRODUCT_STOCK:
      return {
        ...state,
        searchProductStockSuccess: [],
        searchProductStockError: [],
        searchProductStockLoading: true,
      };
    case SEARCH_PRODUCT_STOCK_SUCCESS:
      return {
        ...state,
        searchProductStockSuccess: action.payload,
        searchProductStockError: [],
        searchProductStockLoading: false,
      };
    case SEARCH_PRODUCT_STOCK_ERROR:
      return {
        ...state,
        searchProductStockSuccess: [],
        searchProductStockError: action.payload,
        searchProductStockLoading: false,
      };
    case SEARCH_PRODUCT_STOCK_TRANSACTION:
      return {
        ...state,
        searchProductStockTransactionSuccess: [],
        searchProductStockTransactionError: [],
        searchProductStockTransactionLoading: true,
      };
    case SEARCH_PRODUCT_STOCK_TRANSACTION_SUCCESS:
      return {
        ...state,
        searchProductStockTransactionSuccess: action.payload,
        searchProductStockTransactionError: [],
        searchProductStockTransactionLoading: false,
      };
    case SEARCH_PRODUCT_STOCK_TRANSACTION_ERROR:
      return {
        ...state,
        searchProductStockTransactionSuccess: [],
        searchProductStockTransactionError: action.payload,
        searchProductStockTransactionLoading: false,
      };
    case GET_PRODUCT_STOCK_TRANSACTION_LIST:
      return {
        ...state,
        productStockTransactionListSuccess: [],
        productStockTransactionListError: [],
        productStockTransactionListLoading: true,
      };
    case GET_PRODUCT_STOCK_TRANSACTION_LIST_SUCCESS:
      return {
        ...state,
        productStockTransactionListSuccess: action.payload,
        productStockTransactionListError: [],
        productStockTransactionListLoading: false,
      };
    case GET_PRODUCT_STOCK_TRANSACTION_LIST_ERROR:
      return {
        ...state,
        productStockTransactionListSuccess: [],
        productStockTransactionListError: action.payload,
        productStockTransactionListLoading: false,
      };
    case ADD_PRODUCT_STOCK_TRANSACTION:
      return {
        ...state,
        addProductStockTransactionSuccess: [],
        addProductStockTransactionError: [],
        addProductStockTransactionLoading: true,
      };
    case ADD_PRODUCT_STOCK_TRANSACTION_SUCCESS:
      return {
        ...state,
        addProductStockTransactionSuccess: action.payload,
        addProductStockTransactionError: [],
        addProductStockTransactionLoading: false,
      };
    case ADD_PRODUCT_STOCK_TRANSACTION_ERROR:
      return {
        ...state,
        addProductStockTransactionSuccess: [],
        addProductStockTransactionError: action.payload,
        addProductStockTransactionLoading: false,
      };
    case MOVE_PRODUCT_STOCK_TRANSACTION:
      return {
        ...state,
        moveProductStockTransactionSuccess: [],
        moveProductStockTransactionError: [],
        moveProductStockTransactionLoading: true,
      };
    case MOVE_PRODUCT_STOCK_TRANSACTION_SUCCESS:
      return {
        ...state,
        moveProductStockTransactionSuccess: action.payload,
        moveProductStockTransactionError: [],
        moveProductStockTransactionLoading: false,
      };
    case MOVE_PRODUCT_STOCK_TRANSACTION_ERROR:
      return {
        ...state,
        moveProductStockTransactionSuccess: [],
        moveProductStockTransactionError: action.payload,
        moveProductStockTransactionLoading: false,
      };
    case REDUCE_PRODUCT_STOCK_TRANSACTION:
      return {
        ...state,
        reduceProductStockTransactionSuccess: [],
        reduceProductStockTransactionError: [],
        reduceProductStockTransactionLoading: true,
      };
    case REDUCE_PRODUCT_STOCK_TRANSACTION_SUCCESS:
      return {
        ...state,
        reduceProductStockTransactionSuccess: action.payload,
        reduceProductStockTransactionError: [],
        reduceProductStockTransactionLoading: false,
      };
    case REDUCE_PRODUCT_STOCK_TRANSACTION_ERROR:
      return {
        ...state,
        reduceProductStockTransactionSuccess: [],
        reduceProductStockTransactionError: action.payload,
        reduceProductStockTransactionLoading: false,
      };
    case GET_PRODUCT_STOCK_TRANSACTION_REASON_LIST:
      return {
        ...state,
        productStockTransactionReasonListSuccess: [],
        productStockTransactionReasonListError: [],
        productStockTransactionReasonListLoading: true,
      };
    case GET_PRODUCT_STOCK_TRANSACTION_REASON_LIST_SUCCESS:
      return {
        ...state,
        productStockTransactionReasonListSuccess: action.payload,
        productStockTransactionReasonListError: [],
        productStockTransactionReasonListLoading: false,
      };
    case GET_PRODUCT_STOCK_TRANSACTION_REASON_LIST_ERROR:
      return {
        ...state,
        productStockTransactionReasonListSuccess: [],
        productStockTransactionReasonListError: action.payload,
        productStockTransactionReasonListLoading: false,
      };
    case CREATE_PRODUCT_STOCK_TRANSACTION_REASON:
      return {
        ...state,
        createProductStockTransactionReasonSuccess: [],
        createProductStockTransactionReasonError: [],
        createProductStockTransactionReasonLoading: true,
      };
    case CREATE_PRODUCT_STOCK_TRANSACTION_REASON_SUCCESS:
      return {
        ...state,
        createProductStockTransactionReasonSuccess: action.payload,
        createProductStockTransactionReasonError: [],
        createProductStockTransactionReasonLoading: false,
      };
    case CREATE_PRODUCT_STOCK_TRANSACTION_REASON_ERROR:
      return {
        ...state,
        createProductStockTransactionReasonSuccess: [],
        createProductStockTransactionReasonError: action.payload,
        createProductStockTransactionReasonLoading: false,
      };
    case UPDATE_PRODUCT_STOCK_TRANSACTION_REASON:
      return {
        ...state,
        updateProductStockTransactionReasonSuccess: [],
        updateProductStockTransactionReasonError: [],
        updateProductStockTransactionReasonLoading: true,
      };
    case UPDATE_PRODUCT_STOCK_TRANSACTION_REASON_SUCCESS:
      return {
        ...state,
        updateProductStockTransactionReasonSuccess: action.payload,
        updateProductStockTransactionReasonError: [],
        updateProductStockTransactionReasonLoading: false,
      };
    case UPDATE_PRODUCT_STOCK_TRANSACTION_REASON_ERROR:
      return {
        ...state,
        updateProductStockTransactionReasonSuccess: [],
        updateProductStockTransactionReasonError: action.payload,
        updateProductStockTransactionReasonLoading: false,
      };
    case DELETE_PRODUCT_STOCK_TRANSACTION_REASON:
      return {
        ...state,
        deleteProductStockTransactionReasonSuccess: [],
        deleteProductStockTransactionReasonError: [],
        deleteProductStockTransactionReasonLoading: true,
      };
    case DELETE_PRODUCT_STOCK_TRANSACTION_REASON_SUCCESS:
      return {
        ...state,
        deleteProductStockTransactionReasonSuccess: action.payload,
        deleteProductStockTransactionReasonError: [],
        deleteProductStockTransactionReasonLoading: false,
      };
    case DELETE_PRODUCT_STOCK_TRANSACTION_REASON_ERROR:
      return {
        ...state,
        deleteProductStockTransactionReasonSuccess: [],
        deleteProductStockTransactionReasonError: action.payload,
        deleteProductStockTransactionReasonLoading: false,
      };
    case GET_UNIT_MEASUREMENT_LIST:
      return {
        ...state,
        unitMeasurementListSuccess: [],
        unitMeasurementListError: [],
        unitMeasurementListLoading: true,
      };
    case GET_UNIT_MEASUREMENT_LIST_SUCCESS:
      return {
        ...state,
        unitMeasurementListSuccess: action.payload,
        unitMeasurementListError: [],
        unitMeasurementListLoading: false,
      };
    case GET_UNIT_MEASUREMENT_LIST_ERROR:
      return {
        ...state,
        unitMeasurementListSuccess: [],
        unitMeasurementListError: action.payload,
        unitMeasurementListLoading: false,
      };

    default:
      return { ...state };
  }
};

export default ProductCrmIT;
